import type { Company, User } from '@/types';

/** Restore sidebar company after reload — falls back to first membership. */
export function pickInitialCompany(user: User): Company | null {
  const memberships = Object.values(user.memberships);
  if (memberships.length === 0) return null;

  const preferredId = user.lastSelectedCompanyId;
  if (preferredId) {
    const hit = memberships.find((m) => m.companyId === preferredId);
    if (hit) return hit.company;
  }

  return memberships[0]?.company ?? null;
}
